export enum NETSUITE_ACTIONS {
  getNetSuiteMasterProjectsRequest = 'netsuite/getNetSuiteMasterProjectsRequest'
}
